export const parseNestError = (error: unknown): string => {
  if (!(error instanceof Error)) {
    return 'Something went wrong'
  }

  // сетевая ошибка Nest-клиента несёт обычный текст, не JSON
  try {
    return JSON.parse(error.message)?.message
  } catch {
    return 'Something went wrong'
  }
}
